import { render, staticRenderFns } from "./AttendeeDetailsPage.vue?vue&type=template&id=332ca6ec&scoped=true"
import script from "./AttendeeDetailsPage.vue?vue&type=script&lang=js"
export * from "./AttendeeDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./AttendeeDetailsPage.vue?vue&type=style&index=0&id=332ca6ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332ca6ec",
  null
  
)

export default component.exports